import React, { useState } from "react";
import "./ourservices.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import luxury1 from "../../assets/Interior Website Images/Living Hall Design/Luxury Design 1.jpeg";
import luxury2 from "../../assets/Interior Website Images/Living Hall Design/Luxury Design 2.jpg";
import luxury3 from "../../assets/Interior Website Images/Living Hall Design/Luxury Design 3.jpg";
import modern1 from "../../assets/Interior Website Images/Living Hall Design/Modern Design 1.jpeg";
import modern2 from "../../assets/Interior Website Images/Living Hall Design/Modern Design 2.jpg";
import modern3 from "../../assets/Interior Website Images/Living Hall Design/Modern Design 3.jpg";
import warm1 from "../../assets/Interior Website Images/Living Hall Design/Warm Living Spaces 1.jpg";
import warm2 from "../../assets/Interior Website Images/Living Hall Design/Warm Living Space 2.jpg";
import warm3 from "../../assets/Interior Website Images/Living Hall Design/Warm Living Space 3.jpg";
import Green1 from "../../assets/Interior Website Images/Balcony Design/Green Garden Seatout Balcony 1.jpg";
import Green2 from "../../assets/Interior Website Images/Balcony Design/Green Garden Seatout Balcony 2.jpg";
import Green3 from "../../assets/Interior Website Images/Balcony Design/Green Garden Seatout Balcony 3.jpg";
import small1 from "../../assets/Interior Website Images/Balcony Design/Small & Space-Saving Balcony 1.jpg";
import small2 from "../../assets/Interior Website Images/Balcony Design/Small & Space-Saving Balcony 2.jpg";
import small3 from "../../assets/Interior Website Images/Balcony Design/Small & Space-Saving Balcony 3.jpg";
import cozy1 from "../../assets/Interior Website Images/Balcony Design/Cozy Balcony With Seating Nook 1.jpg";
import cozy2 from "../../assets/Interior Website Images/Balcony Design/Cozy Balcony With Seating Nook 2.jpg";
import cozy3 from "../../assets/Interior Website Images/Balcony Design/Cozy Balcony With Seating Nook 3.jpg";
import Lshape1 from "../../assets/Interior Website Images/Modular Kitchen Design/L- Shaped Kitchen 1.jpg";
import Lshape2 from "../../assets/Interior Website Images/Modular Kitchen Design/L- Shaped Kitchen 2.jpg";
import Lshape3 from "../../assets/Interior Website Images/Modular Kitchen Design/L- Shaped Kitchen 3.jpg";
import Ushape1 from "../../assets/Interior Website Images/Modular Kitchen Design/U- Shaped Kitchen 1.jpg";
import Ushape2 from "../../assets/Interior Website Images/Modular Kitchen Design/U-Shaped Kitchen 2.jpg";
import Ushape3 from "../../assets/Interior Website Images/Modular Kitchen Design/U-Shaped Kitchen 3.jpg";
import straight1 from "../../assets/Interior Website Images/Modular Kitchen Design/Straight Kitchen 1.jpg";
import straight2 from "../../assets/Interior Website Images/Modular Kitchen Design/Straight Kitchen 2.jpg";
import straight3 from "../../assets/Interior Website Images/Modular Kitchen Design/Straight Kitchen 3.jpg";
import luxurydesign1 from "../../assets/Interior Website Images/Dining Hall Design/Luxury Dining Hall 1.jpg";
import luxurydesign2 from "../../assets/Interior Website Images/Dining Hall Design/Luxury Dining Hall 2.jpg";
import luxurydesign3 from "../../assets/Interior Website Images/Dining Hall Design/Luxury Dining Hall 3.jpg";
import normaldesign1 from "../../assets/Interior Website Images/Dining Hall Design/Normal Dining Hall 1.jpg";
import normaldesign2 from "../../assets/Interior Website Images/Dining Hall Design/Normal Dining Hall 2.jpg";
import normaldesign3 from "../../assets/Interior Website Images/Dining Hall Design/Normal Dining Hall 3.jpg";
import Traditionaldesign1 from "../../assets/Interior Website Images/Dining Hall Design/Traditional Dining Hall 1.jpg";
import Traditionaldesign2 from "../../assets/Interior Website Images/Dining Hall Design/Traditional Dining Hall 2.jpg";
import Traditionaldesign3 from "../../assets/Interior Website Images/Dining Hall Design/Traditional Dining Hall 3.jpg";
import mordernmaster1 from "../../assets/Interior Website Images/Master Bedroom Design/Modern Master Bedroom 1.jpg";
import mordernmaster2 from "../../assets/Interior Website Images/Master Bedroom Design/Modern Master Bedroom 2.jpg";
import mordernmaster3 from "../../assets/Interior Website Images/Master Bedroom Design/Modern Master Bedroom 3.jpg";
import luxurymaster1 from "../../assets/Interior Website Images/Master Bedroom Design/Luxury Master Bedroom 1.jpg";
import luxurymaster2 from "../../assets/Interior Website Images/Master Bedroom Design/Luxury Master Bedroom 2.jpg";
import luxurymaster3 from "../../assets/Interior Website Images/Master Bedroom Design/Luxury Master Bedroom 3.jpg";
import Normalmaster1 from "../../assets/Interior Website Images/Master Bedroom Design/Normal Master Bedroom 1.jpg";
import Normalmaster2 from "../../assets/Interior Website Images/Master Bedroom Design/Normal Master Bedroom 2.jpg";
import Normalmaster3 from "../../assets/Interior Website Images/Master Bedroom Design/Normal Master Bedroom 3.jpg";
import Mwardrobe1 from "../../assets/Interior Website Images/Wardrobe Design/Modular Wardrobe 1.jpg";
import Mwardrobe2 from "../../assets/Interior Website Images/Wardrobe Design/Modular Wardrobe 2.jpg";
import Mwardrobe3 from "../../assets/Interior Website Images/Wardrobe Design/Modular Wardrobe 3.jpg";
import slidewardrobe1 from "../../assets/Interior Website Images/Wardrobe Design/Sliding Wardrobe Design 1.jpg";
import slidewardrobe2 from "../../assets/Interior Website Images/Wardrobe Design/Sliding Wardrobe Design 2.jpg";
import slidewardrobe3 from "../../assets/Interior Website Images/Wardrobe Design/Sliding Wardrobe Design 3.jpg";
import hingedwardrobe1 from "../../assets/Interior Website Images/Wardrobe Design/Hinged Door Wardrobe 1.jpg";
import hingedwardrobe2 from "../../assets/Interior Website Images/Wardrobe Design/Hinged Door Wardrobe 2.jpg";
import hingedwardrobe3 from "../../assets/Interior Website Images/Wardrobe Design/Hinged Door Wardrobe 3.jpg";
import Mordernbath1 from "../../assets/Interior Website Images/Bathroom Design/Modern Bathroom 1.jpg";
import Mordernbath2 from "../../assets/Interior Website Images/Bathroom Design/Modern Bathroom 2.jpg";
import Mordernbath3 from "../../assets/Interior Website Images/Bathroom Design/Modern Bathroom 3.jpg";
import compactbath1 from "../../assets/Interior Website Images/Bathroom Design/Compact Small Space Bathroom 1.jpg";
import compactbath2 from "../../assets/Interior Website Images/Bathroom Design/Compact Small Space Bathroom 2.jpg";
import compactbath3 from "../../assets/Interior Website Images/Bathroom Design/Compact Small Space Bathroom 3.jpeg";
import luxurybath1 from "../../assets/Interior Website Images/Bathroom Design/Luxury Spa - Style Bathroom 1.jpg";
import luxurybath2 from "../../assets/Interior Website Images/Bathroom Design/Luxury Spa - Style Bathroom 2.jpg";
import luxurybath3 from "../../assets/Interior Website Images/Bathroom Design/Luxury Spa - Style Bathroom 3.jpg";
import ledtv1 from "../../assets/Interior Website Images/TV Unit Design/LED Backlit TV Unit 1.jpg";
import ledtv2 from "../../assets/Interior Website Images/TV Unit Design/LED Backlit TV Unit 2.jpg";
import ledtv3 from "../../assets/Interior Website Images/TV Unit Design/LED Backlit TV Unit 3.jpg";
import stonetv1 from "../../assets/Interior Website Images/TV Unit Design/Marble Or Stone Finish Tv Unit 1.jpg";
import stonetv2 from "../../assets/Interior Website Images/TV Unit Design/Marble Or Stone Finish Tv Unit 2.jpg";
import stonetv3 from "../../assets/Interior Website Images/TV Unit Design/Marble Or Stone Finish Tv Unit 3.jpg";
import walltv1 from "../../assets/Interior Website Images/TV Unit Design/Wall - Mounted TV Unit 1.jpg";
import walltv2 from "../../assets/Interior Website Images/TV Unit Design/Wall - Mounted TV Unit 2.jpg";
import walltv3 from "../../assets/Interior Website Images/TV Unit Design/Wall - Mounted TV Unit 3.jpg";
import studykid1 from "../../assets/Interior Website Images/Kids Room Design/Study - Focused Kids Room 1.jpg";
import studykid2 from "../../assets/Interior Website Images/Kids Room Design/Study - Focused Kids Room 2.jpg";
import studykid3 from "../../assets/Interior Website Images/Kids Room Design/Study - Focused Kids Room 3.jpg";
import interactivekid1 from "../../assets/Interior Website Images/Kids Room Design/Interactive Kids Room With Activity Zone 1.jpg";
import interactivekid2 from "../../assets/Interior Website Images/Kids Room Design/Interactive Kids Room With Activity Zone 2.jpg";
import interactivekid3 from "../../assets/Interior Website Images/Kids Room Design/Interactive Kids Room With Activity Zone 3.jpg";
import themedkid1 from "../../assets/Interior Website Images/Kids Room Design/Themed Kids Room 1.jpg";
import themedkid2 from "../../assets/Interior Website Images/Kids Room Design/Themed Kids Room 2.jpg";
import themedkid3 from "../../assets/Interior Website Images/Kids Room Design/Themed Kids Room 3.jpg";
import poojadesign1 from "../../assets/Interior Website Images/Prayer Hall Design/Pooja Mandir Design 1.jpg"
import poojadesign2 from "../../assets/Interior Website Images/Prayer Hall Design/Pooja Mandir Design 2.jpeg"
import poojadesign3 from "../../assets/Interior Website Images/Prayer Hall Design/Pooja Mandir Design 3.jpeg"
import islamicdesign1 from "../../assets/Interior Website Images/Prayer Hall Design/Islamic Prayer Hall Design 1.jpeg"
import islamicdesign2 from "../../assets/Interior Website Images/Prayer Hall Design/Islamic Prayer Hall Design 2.jpeg"
import islamicdesign3 from "../../assets/Interior Website Images/Prayer Hall Design/Islamic Prayer Hall Design 3.jpeg"
import automobile1 from "../../assets/Interior Website Images/Showroom Design/automobile1.jpeg"
import automobile2 from "../../assets/Interior Website Images/Showroom Design/automobile2.jpeg"
import automobile3 from "../../assets/Interior Website Images/Showroom Design/automobile3.jpeg"
import cosmatic1 from "../../assets/Interior Website Images/Showroom Design/showroom images (1).jpg"
import cosmatic2 from "../../assets/Interior Website Images/Showroom Design/showroom images (2).jpg"
import cosmatic3 from "../../assets/Interior Website Images/Showroom Design/showroom images (3).jpg"
import modernfabric1 from "../../assets/Interior Website Images/Showroom Design/modernfabric1.jpeg"
import modernfabric2 from "../../assets/Interior Website Images/Showroom Design/modernfabric2.jpeg"
import modernfabric3 from "../../assets/Interior Website Images/Showroom Design/modernfabric3.jpeg"
import Concrete from "../../assets/Interior Website Images/Flooring gesign/Concrete Flooring.jpeg"
import Carpet from "../../assets/Interior Website Images/Flooring gesign/Carpet Flooring.jpeg"
import Granite from "../../assets/Interior Website Images/Flooring gesign/Granite Flooring.jpeg"
import Marble from "../../assets/Interior Website Images/Flooring gesign/Marble Flooring.jpeg"
import Terrazzo from "../../assets/Interior Website Images/Flooring gesign/Terrazzo Flooring.jpeg"
import titlesflooring from "../../assets/Interior Website Images/Flooring gesign/Tiles Flooring.jpeg"
import vinyl from "../../assets/Interior Website Images/Flooring gesign/Vinyl Flooring.jpeg"
import wooden from "../../assets/Interior Website Images/Flooring gesign/Wooden Flooring.jpeg"
import Glossy from "../../assets/Interior Website Images/Wall Paint Design/Glossy & Semi-Gloss Paint.jpeg";
import Marblefinish from "../../assets/Interior Website Images/Wall Paint Design/Marble Finish Wall Paint.jpeg";
import Matte from "../../assets/Interior Website Images/Wall Paint Design/Matte Finish Paint.jpeg";
import Satin from "../../assets/Interior Website Images/Wall Paint Design/Satin &Eggshell Finish Paint.jpeg";
import stencil from "../../assets/Interior Website Images/Wall Paint Design/Stencil Wall Paint.jpeg";
import metalic from "../../assets/Interior Website Images/Wall Paint Design/Metallic wall paint.jpeg";
import venetianplaster from "../../assets/Interior Website Images/Wall Paint Design/Venetian Plaster wall paint.jpeg";
import Texturedpaint from "../../assets/Interior Website Images/Wall Paint Design/Textured Paint.jpeg";
import luxuryfalse from "../../assets/Interior Website Images/False Ceiling Design/Luxury False Ceiling.jpg";
import officearea from "../../assets/Interior Website Images/False Ceiling Design/Office Area False Ceiling Design.jpg";
import showroomsfalse from "../../assets/Interior Website Images/False Ceiling Design/Showroom False Ceiling.jpg";
import Popupboxx from "../popupboxx/Popupboxx";




function Ourservices() {
    const [selectedService, setSelectedService] = useState("LivingHallDesign");
    const [isPopupOpen, setIsPopupOpen] = useState(false);


    // Each service has multiple items
    const services = {
        LivingHallDesign: [
            {
                title: "Modern Design",
                title_description: "Sleek, minimalist designs with functional layouts and contemporary finishes to suit modern lifestyles.",
                images: modern2,
            },
            {
                title: "Luxury Design",
                title_description: "Exquisite, high-end materials and elegant details that create a lavish and sophisticated atmosphere.",

                images: luxury2,
            },
            {
                title: "Warm Living Space Design",
                title_description: "Inviting and cozy designs with soft tones, natural textures, and a homely ambiance for comfort and relaxation.",

                images: warm2,
            },
        ],
        ModularKitchenDesign: [
            {
                title: "Straight Kitchen",
                title_description: "A sleek, space-efficient design ideal for smaller areas, with everything in a single line for easy access.",

                images: straight1,
            },
            {
                title: "L-Shaped Kitchen",
                title_description: "Perfect for open spaces, this design offers ample counter space and storage, making cooking a breeze.",

                images: Lshape2,
            },
            {
                title: "U-Shaped Kitchen",
                title_description: "A highly functional layout with three sides of cabinets, maximizing storage and workspace for larger kitchens.",

                images: Ushape1,
            },
        ],
        MasterBedroomDesign: [
            {
                title: "Mordern Master Bedroom",
                title_description: "Sleek lines, minimalist decor, and contemporary finishes for a fresh, stylish retreat.",

                images: mordernmaster2,
            },
            {
                title: "Luxury Master Bedroom",
                title_description: "Opulent designs with premium materials, elegant furnishings, and sophisticated details for a lavish escape.",

                images: luxurymaster1,
            },
            {
                title: "Normal Master Bedroom",
                title_description: "A practical and comfortable design that balances style and function for everyday living.",

                images: Normalmaster1,
            },
        ],
        DiningHallDesign: [
            {
                title: "Straight Kitchen",
                title_description: "A sleek, space-efficient design ideal for smaller areas, with everything in a single line for easy access.",

                images: straight1,
            },
            {
                title: "L-Shaped Kitchen",
                title_description: "Perfect for open spaces, this design offers ample counter space and storage, making cooking a breeze.",

                images: Lshape2,
            },
            {
                title: "U-Shaped Kitchen",
                title_description: "A highly functional layout with three sides of cabinets, maximizing storage and workspace for larger kitchens.",

                images: Ushape1,
            },
        ],
        WardrobeDesign: [
            {
                title: "Modular Wardrobe",
                title_description: "Customizable storage units that maximize space with flexible designs for every need.",

                images: Mwardrobe1,
            },
            {
                title: "Sliding Door Wardrobe",
                title_description: "Space-saving wardrobes with smooth sliding doors, perfect for smaller rooms.",

                images: slidewardrobe1,
            },
            {
                title: "Hinged Door Wardrobe",
                title_description: "Classic and sturdy design with outward-opening doors, ideal for spacious rooms with easy access.",

                images: hingedwardrobe1,
            },
        ],
        BathroomDesign: [
            {
                title: "Modern Bathroom",
                title_description: "Clean lines, contemporary fixtures, and minimalist design for a sleek and fresh look.",

                images: Mordernbath1,
            },
            {
                title: "Luxury Spa-Style Bathroom",
                title_description: "Opulent features, indulgent finishes, and soothing elements to create a relaxing, spa-like experience.",

                images: luxurybath1,
            },
            {
                title: "Compact Small-Space Bathroom",
                title_description: "Efficient, space-saving designs that maximize functionality without compromising on style",

                images: compactbath1,
            },
        ],
        BalconyDesign: [
            {
                title: "Green Garden Sit-out Balcony",
                title_description: "A lush, natural retreat with plants and seating for a peaceful outdoor experience.",

                images: Green1,
            },
            {
                title: "Small & Space-Saving Balcony",
                title_description: "Clever, compact designs that make the most of limited space without sacrificing style.",

                images: small1,
            },
            {
                title: "Cozy Balcony with Seating Nook",
                title_description: "A warm, inviting space with a comfortable seating area for relaxation and enjoying the outdoors.",

                images: cozy1,
            },
        ],
        TVUnitDesign: [
            {
                title: "Wall-Mounted TV Unit",
                title_description: "Sleek and modern, this design saves space while giving a clean, floating look to your TV area.",

                images: walltv1,
            },
            {
                title: "LED Backlit TV Unit",
                title_description: "A contemporary design with LED lighting to add ambiance and highlight your TV unit in style.",

                images: ledtv2,
            },
            {
                title: "Marble or Stone Finish TV Unit",
                title_description: "Luxurious and sophisticated, with premium marble or stone finishes that add elegance and durability to your space.",

                images: stonetv2,
            },
        ],
        KidsRoomDesign: [

            {
                title: "Study-Focused Kids' Room",
                title_description: "Designed with ample storage, a comfortable study area, and a calming ambiance to promote learning and focus.",

                images: studykid1,
            },
            {
                title: "Themed Kids' Room",
                title_description: "Fun, imaginative designs based on your child’s favorite themes, from superheroes to fantasy worlds, for a playful environment.",

                images: themedkid1,
            },
            {
                title: "Interactive Kids’ Room with Activity Zone",
                title_description: "An engaging space with designated areas for learning, play, and creativity, encouraging interaction and exploration.",

                images: interactivekid1,
            },
        ],

        Prayarhalldesign: [
            {
                title: "Pooja Mandir Design",
                title_description: "Elegant and spiritual designs for a dedicated space for Hindu rituals, featuring traditional or modern elements, depending on your style.",

                images: poojadesign1,
            },
            {
                title: "Islamic Prayer Hall",
                title_description: "Peaceful and serene designs with specific features like Qibla alignment, intricate detailing, and a calm, reflective atmosphere for prayer.",

                images: islamicdesign1,
            },

        ],


        FalseCeilingDesign: [
            {
                title: "Commercial Luxury False Ceiling",
                title_description: "Opulent designs with high-end materials and intricate patterns that elevate the overall elegance of your space.",

                images: luxuryfalse,
            },
            {
                title: "Showrooms False Ceiling",
                title_description: "Modern and sleek designs with lighting elements that create a stylish, attention-grabbing atmosphere for retail spaces.",

                images: showroomsfalse,
            },
            {
                title: "Office Area False Ceiling",
                title_description: "Functional and professional designs that offer sound insulation, lighting solutions, and a clean, organized look for office environments.",

                images: officearea,
            },
        ],
        WallPaintDesign: [
            {
                title: "Textured Paint",
                title_description: "Adds depth and dimension to your walls with a variety of unique textures, creating a distinctive, artistic look.",

                images: [Texturedpaint],
            },
            {
                title: "Matte Finish Pain",
                title_description: "A smooth, non-reflective finish that offers a sophisticated and subtle look, perfect for a modern, minimalist aesthetic.",

                images: [Matte],
            },
            {
                title: "Satin & Eggshell Finish Paint",
                title_description: "Satin offers a soft sheen, while eggshell provides a smooth, low-gloss finish, ideal for durability and a soft look.",

                images: [Satin],
            },
            {
                title: "Glossy & Semi-Gloss Paint",
                title_description: "High-shine finishes that are easy to clean, perfect for areas requiring a sleek, reflective surface and added durability.",

                images: [Glossy],
            },
            {
                title: "Metallic Wall Paint",
                title_description: "Gives walls a stunning reflective surface, adding a touch of glamour and sophistication with metallic sheens.",

                images: [metalic],
            },
            {
                title: "Marble Finish Wall Paint",
                title_description: "A luxurious, marble-like effect for walls, offering a sophisticated and elegant appearance with textured depth.",

                images: [Marblefinish],
            },
            {
                title: "Venetian Plaster",
                title_description: "A smooth, polished finish with a subtle sheen, giving walls an elegant, timeless look with depth and texture.",

                images: [venetianplaster],
            },
            {
                title: "Stencil Wall Paint",
                title_description: "Creative designs and patterns applied using stencils, perfect for adding a personal touch and unique charm to your walls.",

                images: [stencil],
            },
        ],
        FlooringDesign: [
            {
                title: "Marble Flooring",
                title_description: "Luxurious and timeless, marble offers elegance and durability with its unique veining and smooth finish.",

                images: [Marble],
            },
            {
                title: "Granite Flooring",
                title_description: "Strong, durable, and sleek, granite provides a high-end, polished look with minimal maintenance.",

                images: [Granite],
            },
            {
                title: "Wooden Flooring",
                title_description: "Warm and natural, wooden floors bring richness and charm, available in various finishes and textures.",

                images: [wooden],
            },
            {
                title: "Tile Flooring",
                title_description: "Versatile and easy to maintain, tiles come in various styles, from classic to contemporary, offering durability and style.",

                images: [titlesflooring],
            },
            {
                title: "Vinyl Flooring",
                title_description: "Affordable and versatile, vinyl provides comfort and resilience with a variety of patterns and finishes.",

                images: [vinyl],
            },
            {
                title: "Terrazzo Flooring",
                title_description: "A unique, decorative flooring option made from chips of marble, quartz, or granite, creating a bold and vibrant look.",

                images: [Terrazzo],
            },
            {
                title: "Concrete Flooring",
                title_description: "Industrial and modern, concrete offers a minimalistic, durable surface that can be polished or textured.",

                images: [Concrete],
            },
            {
                title: "Carpet Flooring",
                title_description: "Soft and cozy, carpet flooring adds warmth and texture, available in a wide range of colors and patterns for a comfortable feel.",

                images: [Carpet],
            },
        ],
        ShowroomDesign: [
            {
                title: "Compact Cosmetic Showroom",
                title_description: "Elegant and modern designs that highlight beauty products with well-lit displays, creating an inviting and luxurious shopping experience.",

                images: cosmatic1,
            },
            {
                title: "Modern Fabric Showroom",
                title_description: "Stylish and organized layouts with versatile displays to showcase fabrics in a visually appealing and accessible way for customers.",

                images: modernfabric1,
            },
            {
                title: "Automobile Showroom",
                title_description: "Sleek, spacious designs with optimal lighting and layout to showcase vehicles in an open, professional, and engaging environment.",

                images: automobile1,
            },
        ],
    };

    return (
        <>
            <section style={{ marginTop: "50px" }}>
                <div className='heading-head'>
                    <h3 className='heading-h3'>What We OFFER</h3>
                    {/* <div className="underline-oueclient"></div> */}
                </div>

            </section>
            <div className="container main-containerr">
                <div className="col-lg-3 col-md-4 col-sm-12 services-menu">
                    <div>
                        <p
                            onClick={() => setSelectedService("LivingHallDesign")}
                            className={selectedService === "LivingHallDesign" ? "active" : ""}
                        >
                            Living Hall Design
                        </p>
                        <p
                            onClick={() => setSelectedService("ModularKitchenDesign")}
                            className={selectedService === "ModularKitchenDesign" ? "active" : ""}
                        >
                            Modular Kitchen Design
                        </p>
                        <p
                            onClick={() => setSelectedService("DiningHallDesign")}
                            className={selectedService === "DiningHallDesign" ? "active" : ""}
                        >
                            Dining Hall Design
                        </p>
                        <p
                            onClick={() => setSelectedService("MasterBedroomDesign")}
                            className={selectedService === "MasterBedroomDesign" ? "active" : ""}
                        >
                            Master Bedroom Design
                        </p>
                        <p
                            onClick={() => setSelectedService("WardrobeDesign")}
                            className={selectedService === "WardrobeDesign" ? "active" : ""}
                        >
                            Wardrobe Design
                        </p>
                        <p
                            onClick={() => setSelectedService("BathroomDesign")}
                            className={selectedService === "BathroomDesign" ? "active" : ""}
                        >
                            Bathroom Design
                        </p>
                        <p
                            onClick={() => setSelectedService("BalconyDesign")}
                            className={selectedService === "BalconyDesign" ? "active" : ""}
                        >
                            Balcony Design
                        </p>
                        <p
                            onClick={() => setSelectedService("TVUnitDesign")}
                            className={selectedService === "TVUnitDesign" ? "active" : ""}
                        >
                            TV Unit Design
                        </p>
                        <p
                            onClick={() => setSelectedService("KidsRoomDesign")}
                            className={selectedService === "KidsRoomDesign" ? "active" : ""}
                        >
                            Kids Room Design
                        </p>
                        <p
                            onClick={() => setSelectedService("Prayarhalldesign")}
                            className={selectedService === "Prayarhalldesign" ? "active" : ""}
                        >
                            Prayar Hall Design
                        </p>
                        <p
                            onClick={() => setSelectedService("FalseCeilingDesign")}
                            className={selectedService === "FalseCeilingDesign" ? "active" : ""}
                        >
                            False Ceiling Design
                        </p>
                        <p
                            onClick={() => setSelectedService("WallPaintDesign")}
                            className={selectedService === "WallPaintDesign" ? "active" : ""}
                        >
                            Wall Paint Design
                        </p>
                        <p
                            onClick={() => setSelectedService("FlooringDesign")}
                            className={selectedService === "FlooringDesign" ? "active" : ""}
                        >
                            Flooring Design
                        </p>
                        <p
                            onClick={() => setSelectedService("ShowroomDesign")}
                            className={selectedService === "ShowroomDesign" ? "active" : ""}
                        >
                            Showroom Design
                        </p>
                    </div>
                </div>
                <div className="col-lg-9 col-md-8 col-sm-12 serivce-sub-conatiner">
                    <Swiper modules={[Autoplay, Navigation, Pagination]}
                        autoplay={{ delay: 3000, disableOnInteraction: false }}
                        navigation pagination={{ clickable: true }}
                        loop={true} >

                        {services[selectedService].map((item, index) => (
                            <SwiperSlide key={index}>
                                {/* <div>
                                    <h1>{item.title}</h1>
                                </div> */}
                                <div className="services-card">
                                    <div className="card-image">
                                        <img src={item.images} alt={item.title} />
                                    </div>

                                    <div className="card-content">
                                        <h3>{item.title}</h3>
                                        <p>{item.title_description}</p>
                                        <div  className="d-flex align-items-center justify-content-center" >
                                            <button className="download-btn" onClick={() => setIsPopupOpen(true)}>
                                                Get Details
                                            </button>
                                        </div>
                                        </div>                        
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>

            <Popupboxx
                isOpen={isPopupOpen}
                onClose={() => setIsPopupOpen(false)}
            />

        </>
    );
}

export default Ourservices;
